/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
import formattedHomeFilterValue from 'client/helpers/formattedHomeFilterValue';
import { useState, useEffect, useMemo } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { getProductfilters } from 'client/_redux/actions/productFilter';
import { useAppSelector } from 'client/hooks/useAppSelector';
import { SearchFilterDefaultValueEnum } from 'client/constants/SearchFilterDefaultValueEnum/SearchFilterDefaultValueEnum';

export interface IfilterSearch {
  tripType: string;
  destination: string;
  startDate: string;
  from: string;
  duration: string;
}

// --- helpers safe B2B ---
const safeGet = (key: string) => {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const isB2BConnected = () => Boolean(safeGet('token_b2b'));

// construit querystring propre
const buildQuery = (obj: Record<string, any>) => {
  const qs = new URLSearchParams();

  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    const s = String(v).trim();

    if (!s) return;
    qs.set(k, s);
  });

  const str = qs.toString();

  return str ? `?${str}` : '';
};

const useFilterHomePage = (isFlightPage?: boolean) => {
  const history = useHistory();
  const [responsiveMode, setResponsiveMode] = useState(false);
  const dispatch = useDispatch();

  const { productsFilter, flightsData } = useAppSelector(
    ({ productFilterReducer, flightsReducer }) => ({
      productsFilter: productFilterReducer.productsFilter,
      flightsData: {
        departureDate: flightsReducer.departureDate,
        returningDate: flightsReducer.returningDate,
        destinationCountry: flightsReducer.destinationCountry,
        departureAerport: flightsReducer.departureAerport,
        pax: flightsReducer.pax,
      },
    }),
  );

  const formMethods = useForm<IfilterSearch>({
    defaultValues: {
      tripType: SearchFilterDefaultValueEnum.SÉJOUR,
      destination: flightsData.destinationCountry || SearchFilterDefaultValueEnum.PeuImporte,
      from: flightsData.departureAerport || SearchFilterDefaultValueEnum.TousLesAéroports,
      startDate: SearchFilterDefaultValueEnum.NImporteQuand,
      duration: SearchFilterDefaultValueEnum.PeuImporte,
    },
  });

  const { handleSubmit, watch } = formMethods;
  const flightTabActivated = useMemo(() => watch('tripType') === 'VOLS', [watch]);

  useEffect(() => {
    dispatch(getProductfilters());
  }, [dispatch]);

  const productSearchCriteriaValue = productsFilter?.productsCriteria;

  const onSubmit: SubmitHandler<IfilterSearch> = (values) => {
    const formattedValues = formattedHomeFilterValue(values, productSearchCriteriaValue);

    const from = formattedValues.from || '';
    const country = formattedValues.to || '';
    const duration = formattedValues.duration || '';
    const tripTypeRaw = String(values.tripType || '').toUpperCase();

    let productType = formattedValues['product-type'] || '';

    // ✅ B2B
    if (isB2BConnected()) {
      let typeParam = '';

      if (productType === 'tour') typeParam = 'tour';
      else if (tripTypeRaw.includes('SÉJOUR') || tripTypeRaw.includes('SEJOUR')) {
        typeParam = 'sejour';
      } else if (tripTypeRaw.includes('HÔTEL') || tripTypeRaw.includes('HOTEL')) {
        typeParam = 'hotel';
      } else if (tripTypeRaw.includes('CIRCUIT')) {
        typeParam = 'tour';
      }

      const qs = buildQuery({
        tab: typeParam || 'tous',
        ...(typeParam && typeParam !== 'tous' ? { type: typeParam } : {}),
        ...(from ? { from } : {}),
        ...(duration ? { duration } : {}),
        ...(country ? { country } : {}),
      });

      history.push(`/b2b/catalogue-b2b${qs}#filters`);

      return;
    }

    // ✅ B2C
    // URL métier souhaitée :
    // - Séjour => sejour (URL lisible)
    // - Hôtel  => hotel
    // - Circuit => tour
    if (!productType) {
      if (tripTypeRaw.includes('SÉJOUR') || tripTypeRaw.includes('SEJOUR')) {
        productType = 'sejour';
      } else if (tripTypeRaw.includes('HÔTEL') || tripTypeRaw.includes('HOTEL')) {
        productType = 'hotel';
      } else if (tripTypeRaw.includes('CIRCUIT')) {
        productType = 'tour';
      }
    }

    const qs = buildQuery({
      ...(from ? { from } : {}),
      ...(productType ? { 'product-type': productType } : {}),
      ...(duration ? { duration } : {}),
      ...(country ? { country } : {}),
    });

    history.push(`/products${qs}`);
  };

  const titleSelected = useAppSelector(
    ({ searchBarSelectedFilter }) => searchBarSelectedFilter.filterSelected.title,
  );

  useEffect(() => {
    if (window == undefined) return;
    setResponsiveMode(window.matchMedia('(max-width: 992px)').matches);

    const mq = window.matchMedia('(max-width: 992px)');
    const handler = (e: MediaQueryListEvent) => setResponsiveMode(e.matches);

    mq?.addEventListener?.('change', handler);

    return () => {
      mq?.removeEventListener?.('change', handler);
    };
  }, []);

  return {
    formMethods,
    handleSubmit,
    onSubmit,
    responsiveMode,
    titleSelected,
    productSearchCriteriaValue,
    flightTabActivated,
  };
};

export default useFilterHomePage;
